module.exports = __webpack_public_path__ + "img/qxc_icon.b7b3badd.png";